import React from 'react';
import Typography from '@johnlewispartnership/wtr-ingredients/foundations/typography/index.js';
import { buildElementStyling } from '../utils';
import { RichTextNode } from '../types';

const RichTextH2 = ({ children, value }: RichTextNode) => {
  const { className, style } = buildElementStyling({ baseClass: 'richTextH2', value });
  return (
    <Typography element="h2" className={className} style={style}>
      {children}
    </Typography>
  );
};

RichTextH2.displayName = 'RichTextH2';

export default RichTextH2;
